// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (orientation:landscape){#sign{padding:.1rem 1rem}}#modal-2,.modal-body{padding:0!important}.modal-fullscreen .modal-dialog{max-width:100%;height:100%;margin:0}.modal-fullscreen .modal-content{border:0;border-radius:0;min-height:100%;height:auto;margin:0}#imgSrc{height:300px;width:100%}", ""]);
// Exports
module.exports = exports;
